<template>
  <div class="calico-usage-view-profile-confirmation-page">
    <div class="qa-actions">
      <button
        class="button-primary"
        @click="openConfirm"
      >
        Open “View Profile Confirmation” (remaining > 0)
      </button>

      <button
        class="button-secondary"
        @click="openLimitReached"
      >
        Open “Limit Reached” (remaining = 0)
      </button>
    </div>

    <UsageViewProfileConfirmation
      v-if="open"
      :limit="current.limit"
      :remaining="current.remaining"
      :viewed="current.viewed"
      :days-valid="30"
      :confirming="confirming"
      :error-message="errorMessage"
      @close="open = false"
      @confirm="handleConfirm"
    />
  </div>
</template>

<script>
import UsageViewProfileConfirmation from "@/components/pattern/usageViewProfileConfirmation/index.vue";

export default {
  name: "CalicoUsageViewProfileConfirmationPage",
  components: { UsageViewProfileConfirmation },

  data() {
    return {
      open: false,
      confirming: false,
      errorMessage: "",
      presets: {
        confirm: { limit: 100, remaining: 85, viewed: 15 },
        limit:   { limit: 100, remaining: 0,  viewed: 15 }
      },
      current: { limit: 0, remaining: 0, viewed: 0 }
    };
  },

  methods: {
    openConfirm() {
      this.current = { ...this.presets.confirm };
      this.errorMessage = "";
      this.open = true;
    },
    openLimitReached() {
      this.current = { ...this.presets.limit };
      this.errorMessage = "";
      this.open = true;
    },
    async handleConfirm() {
      this.confirming = true;
      setTimeout(() => {
        this.confirming = false;
        this.open = false;
      }, 800);
    }
  }
};
</script>

<style lang="scss">
.calico-usage-view-profile-confirmation-page {
  width: 100%;
  height: 100vh;
  background: rgb(103, 100, 100);
  @include inset-space($space-medium);
  display: flex;
  align-items: center;
  justify-content: center;

  .qa-actions {
    @include stack-space($space-medium);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
